import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postMethod } from "../../services/ApiCallMethods";

export const revokeInvite = createAsyncThunk(
  "revoke/revokeInvite",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/invokeinvite`, payload);
      const data = await response.json();
      return data.message;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to revoke invite");
    }
  }
);

const revokeInviteSlice = createSlice({
  name: "revoke",
  initialState: {
    loading: false,
    message: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(revokeInvite.pending, (state) => {
        state.loading = true;
        state.message = "";
        state.error = null;
      })
      .addCase(revokeInvite.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.error = null;
      })
      .addCase(revokeInvite.rejected, (state, action) => {
        state.loading = false;
        state.message = "";
        state.error = action.payload;
      });
  },
});

export default revokeInviteSlice.reducer;
